import { getVueTemplate } from "../../_imports/utils/utils.common";
import FormUtils from "./shared/form-utils.vue.common";
import FormsBaseInputField from "../fields/_imports/forms-base-field.vue";
import FormsFieldComponents from "./shared/forms-field-components.vue.common";

export default {
    name: 'forms-field',
    template: getVueTemplate('forms-field'),
    mixins: [
        FormUtils,
        FormsBaseInputField,
        FormsFieldComponents
    ],
    props: {
        field: Object
    },
    data() {
        return {
            isVisible: true
        }
    },
    computed: {
        formVerifyEmailFirst() {
            return this.form.verifyEmailFirst;
        }
    },
    methods: {
        onInnerFieldStateUpdate(state) {
            if ("isVisible" in state) {
                this.isVisible = state.isVisible;
            }

            this.$emit('state-update', state);
        }
    }
};